import { configureStore } from '@reduxjs/toolkit';
import profileReducer from './Reducer/ProfileReducer';
import avtar from "../assets/images/default-avatar.jpg";
const initialState = {
  profileImage: localStorage.getItem("profileImage")
    || avtar,
};
const preloadedState = {
  profile: {
    profileImage: localStorage.getItem("profileImage") || avtar,
    defaultLanguage: {
      id: 1,
      name: "English",
      code: "en",
      status: "ACTIVE",
      is_published: 1,
    },
    manage_question_filters: {
      level: "",
      status: "",
      queType: "",
      selectedSkill: "",
      keyword: "",
      page: 1
    },
    pagination: {
      paginationSize: 10
    }
  }
};
const store = configureStore({
  reducer: {
    profile: profileReducer,
  },
  // preloadedState: initialState,
  preloadedState,
});

export default store;
